export default __webpack_public_path__ + "static/media/next.9c45b233.svg";